// @flow
export { default } from './CategorySupplierItem';



// WEBPACK FOOTER //
// ./src/components/categories/CategorySupplierItem/index.js